import { HUB_DASHBOARD_PERMISSIONS } from '../constants/hub-dashboard.permissions';

/** Post-login / denied-permission landing: hub if allowed, else profile shell. */
export function crmHomeRoute(hasAnyPermission: (perms: string[]) => boolean): string {
  return hasAnyPermission([...HUB_DASHBOARD_PERMISSIONS]) ? '/dashboard' : '/profile';
}
